import { z } from 'zod';
/**
 * Per-item user disposition. Drives the visual state in the items list
 * (sage pill for approved, accent for deferred, rose for declined,
 * ghost for ignored). Mirrors a BriefAction set into a persistent
 * state field for fast UI render.
 */
export const BriefItemDisposition = z.enum([
    'PENDING',
    'APPROVED',
    'DECLINED',
    'DEFERRED',
    'IGNORED',
]);
